import { __decorate } from "tslib";
import React, { Component } from 'react';
import { action, observable } from 'mobx';
import { observer } from 'mobx-react';
import Icon from 'choerodon-ui/lib/icon';
import Menu, { Item } from 'choerodon-ui/lib/rc-components/menu/index';
import { Action } from 'choerodon-ui/lib/trigger/enum';
import Dropdown from '../../dropdown/Dropdown';
import TableContext from '../TableContext';
import { Placements } from '../../dropdown/enum';
import Column from '../Column';
import { stopEvent, stopPropagation } from '../../_util/EventManager';
import autobind from '../../_util/autobind';
function handleMenuClick({ domEvent }) {
    domEvent.preventDefault();
}
let ColumnFilter = class ColumnFilter extends Component {
    constructor(props, context) {
        super(props, context);
        this.setDropDownHidden(true);
    }
    static get contextType() {
        return TableContext;
    }
    saveMenu(node) {
        this.menu = node;
    }
    handleHiddenChange(hidden) {
        this.setDropDownHidden(hidden);
    }
    handleKeyDown(e) {
        if (this.menu && this.menu.onKeyDown(e)) {
            stopEvent(e);
        }
    }
    setDropDownHidden(hidden) {
        this.hidden = hidden;
    }
    render() {
        const { prefixCls } = this.props;
        return (React.createElement("div", { className: `${prefixCls}-columns-chooser`, onFocus: stopPropagation, onMouseDown: stopPropagation, tabIndex: -1 },
            React.createElement(Dropdown, { trigger: [Action.click], placement: Placements.bottomRight, overlay: this.getMenu, hidden: this.hidden, onHiddenChange: this.handleHiddenChange },
                React.createElement(Icon, { type: "view_column", onClick: this.handleKeyDown, style: { cursor: 'pointer' } }))));
    }
    handleMenuSelect({ item: { props: { value }, }, }) {
        const { tableStore: { node } } = this.context;
        value.hidden = false;
        node._cacheCells = null;
        node.forceUpdate();
    }
    handleMenuUnSelect({ item: { props: { value }, }, }) {
        const { tableStore: { node } } = this.context;
        value.hidden = true;
        node._cacheCells = null;
        node.forceUpdate();
    }
    getMenu() {
        const { tableStore: { proPrefixCls, originalChildren, originalColumns } } = this.context;
        const selfPrefixCls = `${proPrefixCls}-columns-chooser`;
        const selectedKeys = [];
        const menuColumns = [];
        if (originalColumns && originalColumns.length) {
            originalColumns.forEach((column) => {
                const newColumn = { ...Column.defaultProps, ...column };
                const { hideable, hidden, title, dataIndex, key } = newColumn;
                if (hideable && title) {
                    const keys = key || dataIndex;
                    if (!hidden) {
                        selectedKeys.push(keys);
                    }
                    const header = typeof title === 'function' ? title() : title;
                    menuColumns.push([column, header, keys]);
                }
            });
        }
        else if (originalChildren && originalChildren.length) {
            // todo children hidden
            originalChildren.forEach((column) => {
                if (React.isValidElement(column)) {
                    const columnChildren = column.props.children;
                    const { hideable, hidden } = column.props;
                    if (hideable && columnChildren[0]) {
                        const key = columnChildren[1].props.dataKey;
                        if (!hidden) {
                            selectedKeys.push(key);
                        }
                        menuColumns.push([column.props, columnChildren[0].props.children, key]);
                    }
                }
            });
        }
        return (React.createElement(Menu, { ref: this.saveMenu, multiple: true, defaultActiveFirst: true, prefixCls: `${proPrefixCls}-dropdown-menu`, className: `${selfPrefixCls}-dropdown-menu`, selectedKeys: selectedKeys, onSelect: this.handleMenuSelect, onDeselect: this.handleMenuUnSelect, onClick: handleMenuClick }, this.getOptions(menuColumns)));
    }
    getOptions(columns) {
        return columns.map(([column, header, key]) => (React.createElement(Item, { key: key, value: column },
            React.createElement("span", null, header))));
    }
};
ColumnFilter.displayName = 'ColumnFilter';
__decorate([
    observable
], ColumnFilter.prototype, "hidden", void 0);
__decorate([
    autobind
], ColumnFilter.prototype, "saveMenu", null);
__decorate([
    autobind
], ColumnFilter.prototype, "handleHiddenChange", null);
__decorate([
    autobind
], ColumnFilter.prototype, "handleKeyDown", null);
__decorate([
    action
], ColumnFilter.prototype, "setDropDownHidden", null);
__decorate([
    autobind,
    action
], ColumnFilter.prototype, "handleMenuSelect", null);
__decorate([
    autobind,
    action
], ColumnFilter.prototype, "handleMenuUnSelect", null);
__decorate([
    autobind
], ColumnFilter.prototype, "getMenu", null);
ColumnFilter = __decorate([
    observer
], ColumnFilter);
export default ColumnFilter;
